import { html } from "lit-element";
import { InspxObjectBase } from './inspx-object-base.js';
import { SharedStyles } from '../styles/shared-styles.js';
import { CardStyles } from '../styles/card-styles.js';
import './inspx-db-images-container.js';
import './inspx-card-group.js';
import './inspx-array-group.js';

import { computeParts } from '../lib/helpers.js';
import { add } from "../styles/icons.js";


class InspxInspectionCard extends InspxObjectBase {
	shouldUpdate() {
		return this.data && this.parts && this.pathprefix;
	}

	constructor() {
		super();
		this.focus({ preventScroll: true });
	}

	render() {
		return html`
			${SharedStyles}     
            ${CardStyles}
            <style>
                inspx-card-group {
                    grid-column: 1/span 2;
                }

                .two-cells {
                    grid-column: 1/span 2;
                }

                .f {
                    grid-template-columns: repeat(auto-fill, minmax(calc(50% - 6px), 1fr));
                }

                .separator, .add-btn{
                    color: var(--secondary-color);
                    fill: var(--secondary-color);
                }

                .add-btn{
                    display: flex;
                    justify-content: flex-end;
                   cursor: pointer;
                }
                

            </style>
			<div class="h">
				${this.cardtitle}
				<slot></slot>
			</div>
			<div class="c">
                
				${this.parts.map(p => this.renderField(p))}
			</div>
			${this.renderImageContainer()}
		`;
	}

	renderImageContainer() {
		if (this.disablePhotos) return;

		return html`
            <inspx-db-images-container class="f" hideContext hideAddButton .imageIds="${this.data.connected_images}" .context="${this.pathprefix}"
                .inspectionid="${this.inspId}">
            </inspx-db-images-container>
		`;
	}

	renderGroupInput(prop) {
		return html`<inspx-card-group .cardtitle="${prop.title}" .collapsed="${prop.collapsedByDefault || false}" .data="${this.data[prop.name] || {}}"
    ?disabled="${prop.readonly || this.disabled}" .parts="${computeParts(prop)}" .pathprefix="${this.pathprefix + "."
            + prop.name}" .invalidFields="${this.invalidFields}"></inspx-card-group>`;
	}
    
	renderArrayGroupInput(prop) {

		let data = this.data[prop.name];
		if(!data.length ){
			data = [];
		}
		let items = [];
		let ind = 0; let i = 0;
		for(let itm of data){
			let i = ind;
			items.push(html`
        
        <inspx-array-group class="two-cells" .cardtitle="${prop.title + ' ' +( ind+1)}" .collapsed="${prop.collapsedByDefault || false}" .data="${itm}"
    ?disabled="${prop.readonly || this.disabled}" .parts="${computeParts(prop.items)}" 
    @delete-item="${(e)=>{ this.deleteArrayItem(prop, i)}}"
    .pathprefix="${this.pathprefix + "." + prop.name+ "."+ ind}" .invalidFields="${this.invalidFields}"></inspx-array-group>
            
            `);
			ind++;
		}

		return html`
        <div class="separator two-cells">${prop.title}</div>
        ${items}
        <div @click="${()=>this.addArrayItem(prop)}" class="add-btn two-cells">
            ${add} Add ${prop.title}
        </div>
        `;
                
	}
	deleteArrayItem(p, ind){

		let name ="delete-group-array-item";
		let data = this.data[p.name];
		let detail = {
			path: this.pathprefix + "." + p.name ,
			target: this,
			value: ind
		}
		this.dispatchEvent(
			new CustomEvent(name, {
				detail: detail,
				composed: true
			})
		);
	}
    
	addArrayItem(p){
		let name ="inspx-change";
		let data = this.data[p.name];
		let detail = {
			path: this.pathprefix + "." + p.name + "." + data.length,
			target: this,
			value: {}
		}
		this.dispatchEvent(
			new CustomEvent(name, {
				detail: detail,
				composed: true
			})
		);
	}
}

window.customElements.define('inspx-inspection-card', InspxInspectionCard);
